import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { Button, Row, Table, Divider, message, Input, Spin, Tag, Tooltip, Drawer } from 'antd';
import Title from 'antd/lib/typography/Title';
import { PopUpForm } from '../../../lib/ui/popupform';
import { Link } from 'react-router-dom';
import { showErrorInNotification, NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, formatMoney } from '../../../lib/util';
import ReconcilerExclusionRules from './recon_exclusion_rules';
import ErrorWrapper from '../../../lib/error_wrapper';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { TransparentButton } from '../../../components/basic_items';
import { AddOutlined, SyncOutlined } from '@material-ui/icons';
const queryString = require('query-string');

const group_fields = [
  {
    index: 'name',
    name: "Name",
    type: 'text',
  },
  {
    index: 'our_data_type_id',
    name: "Our Datatype",
    // type:'select',
    show_update: false,
    filterable: true,
    options: [],
    type: 'networkselect',
    url: '/data-types',
    filterable: true
  },
  {
    index: 'their_data_type_id',
    name: "Their Datatype",
    // type:'select',
    show_update: false,
    filterable: true,
    options: [],
    type: 'networkselect',
    url: '/data-types',
    filterable: true
  },
  {
    index: 'type',
    name: "Processor Type",
    type: 'networkselect',
    url: '/reconciler-types',
    filterable: true
  },
  {
    index: 'manual_rules',
    name: "Manual Rules",
    type: 'form',
    schema: [
      {
        index: 'amount_equal',
        name: "Should Amount be same?",
        help_text: "Alerts user if they try to reconcile transactions with different amount.",
        type: 'bool',
        default: true,
      },
      {
        index: 'maker_checker',
        name: "Maker Checker",
        // help_text:"Alerts user if they try to reconcile transactions with different amount.",
        type: 'bool',
      }
    ]
  }
]

const type_fields = [
  {
    index: 'name',
    name: "Name",
    type: 'text'
  }
]

const group_cols = ({ onEditPressed, onDeletePressed, onExclusionPressed }) => [
  { title: "Name", dataIndex: 'name', key: 'name' },
  {
    title: "Our Datatype", dataIndex: 'our_data_type_id', key: 'our_datatype', render: (id, data) => {
      let ref = data.__references__ || {};
      let our_datatype = ref.our_data_type_id || {};
      return our_datatype.name
    }
  },
  {
    title: "Their Datatype", dataIndex: 'their_data_type_id', key: 'their_datatype', render: (id, data) => {
      let ref = data.__references__ || {};
      let their_datatype = ref.their_data_type_id || {};
      return their_datatype.name
    }
  },
  {
    title: "Type", dataIndex: 'type', key: 'type', render: (id, data) => {
      let ref = data.__references__ || {};
      let type = ref.type || {};
      return type.name
    }
  },
  {
    title: "Amount Eq Flag",
    dataIndex: 'manual_rules',
    key: 'amount_equal',
    render: (manual_rules = {}) => manual_rules.amount_equal ? "Yes" : "No",
    width: 63
  },
  {
    title: "", dataIndex: "id", key: 'id', render: (id, data) => {
      return <span>
        <Button type='link' onClick={() => {
          typeof onEditPressed === 'function' && onEditPressed(data)
        }}>Edit</Button>
        <Divider type='vertical' />
        <Link to={`/settings/reconcilers-group/${id}`}>
          <Button type='link'>View</Button>
        </Link>
        <Divider type='vertical' />
        <Button type='link' onClick={() => {
          typeof onExclusionPressed === 'function' && onExclusionPressed(id)
        }}>Exclusions</Button>
      </span>
    }
  }
]
class ReconcilerGroupList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      edit_id: null,
      form_data: {},
      schema: group_fields,
      form_visibility: false,
      filter_query: {},


      type_form_data: {},
      type_edit_id: null,
      type_form_visibility: false,

      selected_ids: [],
      all_selected: false
    }

    this.list_datatype = RESTExecutor.list().config({
      label: 'data_types',
      params: {
        pagination: false
      }
    }).callbacks((succcess) => {

      let options = [];
      let schema = this.state.schema;
      succcess.result.rows.map((item) => {
        options.push({
          text: item.name,
          value: item.id
        });

        schema.map((item) => {
          if (item.index == 'our_data_type_id' || item.index == 'their_data_type_id') {
            item.options = options
          }
        })
        this.setState({ schema: schema });
      })
    }, (error) => {
      showErrorInNotification(error);
    }).connect(props.domains.datatype);

    this.list_groups = RESTExecutor.list().config({
      label: 'reconciler_group',
      params: {
        per_page: 100
      }
    }).callbacks((success) => {

    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.settings);

    this.post_group = RESTExecutor.post().config({
      label: 'reconciler_group'
    }).callbacks((success) => {
      message.success("Group Added");
      this.list_groups.execute();
      this.setState({
        edit_id: null,
        form_visibility: false,
        form_data: {}
      })
    }).connect(props.domains.settings);

    this.patch_group = RESTExecutor.patch().config({
      label: 'reconciler_group_detail'
    }).callbacks((success) => {
      message.success("Group Modified");
      this.list_groups.execute()
      this.setState({
        edit_id: null,
        form_visibility: false,
        form_data: {}
      })
    }).connect(props.domains.settings);

    this.list_types = RESTExecutor.list().config({
      label: 'reconciler_types',
      params: {
        pagination: false
      }
    }).callbacks((success) => {
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.settings);

    this.post_types = RESTExecutor.post().config({
      label: 'reconciler_types',
    }).callbacks((success) => {
      message.success("Type added.");
      this.setState({ type_form_visibility: false, type_form_data: {}, type_edit_id: null })
      this.list_types.execute();
    }).connect(props.domains.settings);

    this.patch_types = RESTExecutor.patch().config({
      label: 'reconciler_types_detail',
    }).callbacks((success) => {
      message.success("Type modified");
      this.setState({ type_form_visibility: false, type_form_data: {}, type_edit_id: null })
      this.list_types.execute()

    }, (error) => {
      console.log("eror is", error)
    }).connect(props.domains.settings);

    this.export_data = RESTExecutor.post().config({
      label: 'export'
    }).callbacks((success) => {
      this.setState({ selected_ids: [], all_selected: false })
      // console.log("download url",success)
      window.open(success.result.url, '_blank');

    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.settings);







    // this.list_datatype.execute();

    // this.list_groups.execute();
    this.list_types.execute();

    this.delay_search = new NetworkDelaySearch();


  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }

  handlePostPatch = (data) => {
    if (this.state.edit_id) {
      this.patch_group.forId(this.state.edit_id).execute(data);
    } else {
      this.post_group.execute(data);
    }
  }
  handlePostPatchType = (data) => {
    if (this.state.type_edit_id) {
      this.patch_types.forId(this.state.type_edit_id).execute(data);
    } else {
      this.post_types.execute(data);
    }
  }

  render() {
    let list_group_resp = this.list_groups.response();


    let post_types_resp = this.post_types.response();
    let patch_types_resp = this.patch_types.response();
    let list_types_resp = this.list_types.response();
    let type_list = (list_types_resp.result && list_types_resp.result.rows) || [];

    let list_group_data = list_group_resp.result || {};
    let post_group_resp = this.post_group.response();
    let patch_group_resp = this.patch_group.response();

    let rowsData = list_group_data.rows || [];
    let rowsMeta = list_group_resp.meta || {};
    const { filter_query, selected_ids } = this.state
    let export_data_resp = this.export_data.response();

    return (
      <div>
        <BasicHeader no_back title="Reconcilers"
          menu_items={setting_quick_menu}
          right={[
            <TransparentButton
              label="Add New"
              className='cta-primary'
              hint="Add New Processor"
              onClick={() => {
                this.setState({ form_data: {}, edit_id: null, form_visibility: true })
              }}

            />,
            <TransparentButton
              label="Export"
              hint="Export Selected Processor"
              disabled={selected_ids.length == 0}
              onClick={() => {
                this.export_data.execute({
                  reconcilers: this.state.all_selected ? true : selected_ids
                });
              }}

            />
          ]}

        />
        <div className='filter-card'>
          <div className='filter-card-top' style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',

          }}>
            <Input.Search
              placeholder="Search For"
              style={{
              }}
              allowClear
              autoFocus
              value={filter_query.query}
              onChange={(e) => {
                this.stateUpdater({
                  stateKey: 'filter_query', valueKey: 'query', value: e.target.value,
                  callback: () => {
                    this.delay_search.onSearch(() => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                      })
                    })
                  }
                })
              }}
            />
          </div>
        </div>


        <ErrorWrapper
          error={list_group_resp}
          onReload={() => {
            this.list_groups.execute()
          }}
        >
          <div className='default-card' style={{
            padding: 0
          }}>
            <Table
              // rowClassName='hand-cursor'
              className='main-table'
              loading={list_group_resp.fetching || export_data_resp.fetching}
              size='small'
              scroll={{ x: true }}
              rowSelection={{
                onChange: (selected_ids) => {
                  if (selected_ids.length != rowsMeta.data_count) {
                    this.setState({ all_selected: false })
                  }
                  this.setState({ selected_ids })
                },
                selectedRowKeys: selected_ids
              }}
              pagination={{
                simple: false,
                position: 'bottom',
                onChange: (current, size) => {
                  this.props.history.push({
                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                  })
                },
                defaultCurrent: 1,
                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                pageSize: (rowsMeta && rowsMeta.requested_count),

                total: (rowsMeta && rowsMeta.total_count),
                showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${formatMoney(total, 0)} items`
              }}
              rowKey={(record) => record.id}
              columns={group_cols({
                onEditPressed: (data) => {
                  this.setState({
                    form_data: data,
                    form_visibility: true,
                    edit_id: data.id
                  })
                },
                onExclusionPressed: (id) => {
                  this.setState({
                    exclusion_drawer_visibility: true,
                    current_recon_id: id
                  })
                },
              })}
              dataSource={rowsData}
            />
          </div>
        </ErrorWrapper>

        <div className='default-card' style={{
          padding: 8
        }}>
          <PopUpForm
            title="Processor Type"
            forCreate={this.state.type_edit_id
              ? false
              : true}
            initialData={this.state.type_form_data}
            fields={type_fields}
            open={this.state.type_form_visibility}
            networkState={this.state.type_edit_id
              ? patch_types_resp
              : post_types_resp}
            onClose={() => {
              this.setState({ type_form_visibility: false, type_form_data: {}, type_edit_id: null })
            }}
            onSubmit={(data) => {
              this.handlePostPatchType(data);
            }} />

          <Spin spinning={list_types_resp.fetching} tip="Loading...">
            <Row type='flex' justify='space-between' style={{
              alignItems: 'center',
              flexWrap: 'nowrap'
            }}>
              <Title level={4} type='secondary' >Processor Types</Title>
              <span>
                <Button type='link' onClick={() => {
                  this.list_types.execute()
                }}>
                  <SyncOutlined
                    type="sync"
                    spin={list_types_resp.fetching} />
                </Button>

                <Button disabled={list_types_resp.fetching} type='link' onClick={() => {
                  this.setState({
                    type_form_visibility: true,
                    type_form_data: {},
                    type_edit_id: null
                  })
                  // this.list_types.execute()
                }}>
                  <AddOutlined type="plus" />
                </Button>
              </span>
            </Row>
            <Divider style={{ marginTop: 6, marginBottom: 6 }} />
            <Row type='flex'>
              {type_list.map((item) => {
                return <Tooltip title='Click to Edit'><Tag onClick={() => {
                  this.setState({
                    type_form_visibility: true,
                    type_edit_id: item.id,
                    type_form_data: JSON.parse(JSON.stringify(item))
                  })
                }} className='hand-cursor' color='#2db7f5'>{item.name}
                  {/* <Divider type='vertical'/>
        
        <Icon  type="edit" /> */}
                </Tag></Tooltip>
              })}
              {!list_types_resp.fetching && !list_types_resp.error && type_list.length == 0 && <span style={{ opacity: 0.5 }}>No Data</span>}
              {!list_types_resp.fetching && list_types_resp.error && <span style={{ opacity: 0.5 }}>Error Loading Content</span>}

            </Row>
          </Spin>
        </div>


        <PopUpForm
          title="Processor"
          forCreate={this.state.edit_id
            ? false
            : true}
          initialData={this.state.form_data}
          fields={this.state.schema}
          open={this.state.form_visibility}
          networkState={this.state.edit_id
            ? patch_group_resp
            : post_group_resp}
          onClose={() => {
            this.setState({ form_visibility: false, form_data: {}, edit_id: null })
          }}
          onSubmit={(data) => {
            this.handlePostPatch(data);
          }} />

        <Drawer
          title={<Title style={{ margin: 0 }}>Exclusion Rules</Title>}
          placement="right"
          closable={true}
          width='50%'
          destroyOnClose
          onClose={() => {
            this.setState({
              exclusion_drawer_visibility: false,
              current_recon_id: null
            })
          }}
          visible={this.state.exclusion_drawer_visibility}
        >
          <ReconcilerExclusionRules
            // key={`-${this.state.current_recon_id}`}
            recon_id={this.state.current_recon_id}
            group_id={this.group_id}
          />
        </Drawer>
      </div>
    );
  }

  componentDidMount() {
    overrideHeaderTitle("Reconcilers")
    overrideHeaderBack(null);

    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query
      }
    }, () => {
      this.list_groups.config({
        params: {
          ...this.state.filter_query
        }
      }).execute()
    })

  }
  componentWillReceiveProps(nextProps) {

    let new_filter_query = {};
    if ((this.props.location.search !== nextProps.location.search)) {
      const parsed = queryString.parse(nextProps.location.search);
      new_filter_query = parsed;
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...new_filter_query
        }
      }, () => {
        this.list_groups.config({
          params: {
            ...this.state.filter_query
          }
        }).execute()
      })
    } else {
      //   this.list_logs.execute()
    }


  }
}

export default withDomains(ReconcilerGroupList, "settings", "datatype");
